import {NUMBER} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

// Types
// import commaSeperatedNumber from '@drivesally/sally-fw/lib/type/types/commaSeperatedNumber.type';
// import formattedNumber from '@drivesally/sally-fw/lib/type/types/formattedNumber.type';
import integer from '@drivesally/sally-fw/lib/type/types/integer.type';
import number from '@drivesally/sally-fw/lib/type/types/number.type';

export default attribute({
  type: NUMBER,
  attribute: 'odo_reading',
  display: integer,
  input: integer,
  api: number,
  label: {
    default: 'Odometer Reading',
    short: 'Odometer Reading',
  },
});
